import { Box, Typography } from '@mui/material';
import { LoadingSpinner } from '../core/LoadingSpinner';
import { useGetChangelog } from '../hooks/reactQuerys/ChangelogQueries';
import { ReleaseCard } from './ReleaseCard';

export const Changelog = () => {
  const { changelog, isLoadingChangelog } = useGetChangelog();

  if (isLoadingChangelog) {
    return <LoadingSpinner height='80vh' />;
  }

  if (!changelog) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          p: 4,
        }}
      >
        <Typography variant='h5' color='error'>
          Keine Änderungen gefunden
        </Typography>
        <Typography color='text.secondary'>
          Bitte versuchen Sie es später erneut oder kontaktieren Sie den
          Support.
        </Typography>
      </Box>
    );
  }

  return (
    <Box p={4}>
      <Typography variant='h4' component='h1'>
        Neuerungen
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, mt: 4 }}>
        {changelog.releases.map(release => (
          <ReleaseCard key={`release-${release.id}`} release={release} />
        ))}
      </Box>
    </Box>
  );
};
